import { ImageBody } from "../api";
import ImageSelection from "./ImageSelection";
import { Button } from "@/shared/ui/button.tsx";

const getFilteredImages = (value: string, images: ImageBody[] | undefined): ImageBody[] | undefined => {
  if (!images) {
    return [];
  }

  if (!value || value.length === 0) {
    return images
  }

  const filteredImages: ImageBody[] = images.filter(img => (img.prompt !== null && img.prompt.toLowerCase().includes(value)))

  return filteredImages
}


type Props = {
  galleryImages: ImageBody[] | undefined,
  selectedImages: { image_id: number, image_url: string, type: string }[],
  onSelect: (image: { image_id: number, image_url: string, type: string }) => void
  hasNextPage: boolean,
  fetchNextPage: () => void,
  value: string
}

const ImageGrid = ({ galleryImages, onSelect, selectedImages, fetchNextPage, hasNextPage, value }: Props) => {

  return (
    <div className="size-full overflow-auto p-6 pt-0 scrollbar-w-1">
      {galleryImages && <p className="text-sm text-gray-500 font-poppins pb-3">{getFilteredImages(value, galleryImages)?.length} Images found</p>}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {getFilteredImages(value, galleryImages)?.map((image, index) => (
          <ImageSelection
            key={index}
            isSelected={selectedImages.findIndex(img => img.image_id === image.id) !== - 1}
            onSelect={onSelect}
            image={image} />
        ))}
      </div>
      <div className="w-full py-6 flex items-center justify-center">
        {hasNextPage &&
          <Button
            variant="outline"
            className="rounded-full border border-purple-600"
            onClick={() => fetchNextPage()}
          >View More
          </Button>
        }
      </div>
    </div>
  )
}

export default ImageGrid;
